import {inject} from '@angular/core';
import {RedirectFunction} from '@angular/router';
import {GenericAuthService} from '@infrastructure/generic-auth/generic-auth.service';
import {UserType} from '@infrastructure/generic-auth/user-type.enum';

export const authRedirect: RedirectFunction = (): string =>
{
    const authService = inject(GenericAuthService);

    let redirectRoute = 'public-timeline-sharing';

    if (authService.isOwner())
    {
        redirectRoute = UserType.OWNER;
    }
    else if (authService.isAdmin())
    {
        redirectRoute = UserType.ADMIN;
    }
    else if (authService.isClinician())
    {
        redirectRoute = UserType.CLINICIAN;
    }

    return redirectRoute;
};
